export default __webpack_public_path__ + "static/media/quiz_mask.27d37e3c.png";